export default __webpack_public_path__ + "static/media/slider10.7d6cd79b.jpeg";